module.exports = __webpack_public_path__ + "06da329aea5f77ece33c800b7cc9cf24.jpeg";